import React, { useEffect, useState } from "react";
import { Dialog } from 'primereact/dialog';
import { FaUserGroup, FaBookmark } from "react-icons/fa6";
import { useMotionValue, motion, animate } from "framer-motion";
import { convertDate, convertTime } from "../helper";
import { useEvents } from "../hooks/useEvent";
import { getUser } from "../utils/authHelpers";
import toast from 'react-hot-toast';

export const EventModal = ({ visible, onClose, data }) => {
  const { bookEvent, bookEventLoading, bookEventSuccess } = useEvents();
  const token = localStorage.getItem("token");
  const count = useMotionValue(0);
  const [displayCount, setDisplayCount] = useState(0);

  useEffect(() => {
    const controls = animate(count, data?.event_bookings?.length, {
      duration: 5,
      onUpdate: (latest) => setDisplayCount(Math.round(latest)),
    });
    return () => controls.stop();
  }, [data?.event_bookings?.length]);

  const handleBookEvent = async () => {
    const user = getUser(token);
    if (!user) {
      toast.error("Please login to book an event");
      onClose();
      return;
    }
    bookEvent({ userId: user.decodedToken.userId, eventId: data.id });
  };

  useEffect(() => {
    if(bookEventSuccess) {
      onClose();
    }
  },[bookEventSuccess]);

  return (
    <div className="card flex justify-center mx-auto">
      <Dialog
        header={data?.title}
        visible={visible}
        maximizable
        style={{ width: '80vw' }}
        onHide={onClose}
        className="p-0"
      >
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 w-full ">
          {/* Left Column - Event Details */}
          <div className="lg:col-span-2 w-full">
            {data?.images && data.images.length > 0 && data.images[0]?.image_url ? (
              <img
                src={data.images[0].image_url}
                alt={data?.title}
                className="w-full h-56 sm:h-72 md:h-96 lg:h-[30rem] object-contian mb-4 rounded"
              />
            ) : (
              <div className="w-full h-56 sm:h-72 md:h-96 lg:h-[30rem] flex items-center justify-center bg-gray-200 mb-4 rounded">
                <span className="text-gray-500 text-lg sm:text-xl font-semibold">No Image Available</span>
              </div>
            )}
          </div>

          {/* Right Column - Map & Location */}
          <div className="w-full">
            {/* When & Where Section */}
            <div className="bg-gray-100 border rounded">
              <div className="py-2 px-3 border-b">
                <h3 className="text-base sm:text-lg font-semibold">When & Where</h3>
              </div>
              <div className="px-3 py-2 flex flex-col gap-2">
                <p className="text-gray-700 text-sm">{data?.state},</p>
                <p className="text-gray-700 text-sm">{data?.city}</p>
                <p className="text-gray-500 text-sm">{convertDate(data?.date)}</p>
                <p className="text-gray-500 text-sm">{convertTime(data?.time)} (Local Time)</p>
              </div>
            </div>

            <div className="mt-4">
              <h3 className="text-base sm:text-lg font-semibold">People who attended</h3>
              <div className="mt-2 flex gap-2 items-center">
                <FaUserGroup className="text-red-600 border w-10 h-10 sm:w-16 sm:h-16 rounded-md p-2" />
                <motion.pre className="text-2xl sm:text-3xl">{displayCount}</motion.pre>
              </div>
            </div>
            <div className="mt-2">
              <button
                onClick={handleBookEvent}
                className="w-full bg-red-600 text-white py-2 px-4 rounded-md font-semibold flex items-center justify-center gap-2"
              >
                {bookEventLoading ? (
                  <i
                    className="pi pi-spin pi-spinner text-white"
                    style={{ fontSize: "1.5rem" }}
                  ></i>
                ) : (
                  <>
                    <FaBookmark /> <p>Book</p>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
